import { redactString } from './redact';

const CAPACITY = 30;
const buffer = [];

function push(crumb) {
  buffer.push({ ts: new Date().toISOString(), ...crumb });
  if (buffer.length > CAPACITY) buffer.splice(0, buffer.length - CAPACITY);
}

export function pushRouteBreadcrumb({ from, to }) {
  push({ kind: 'route', detail: { from: redactString(from), to: redactString(to) } });
}

export function pushClickBreadcrumb({ tag, role, label }) {
  push({
    kind: 'click',
    detail: {
      tag: redactString(tag),
      role: redactString(role),
      label: redactString(label)
    }
  });
}

export function getBreadcrumbsSnapshot() {
  return buffer.slice();
}

export function clearBreadcrumbs() {
  buffer.length = 0;
}
